export const environment = {
  production: true,
  apiBaseUrl: 'https://webapi.myereturn.com',
  employee:'http://employee.myereturn.com',
  retailer:'https://retailer.myereturn.com',
  distributor:'https://distributor.myereturn.com',
  apiBaseUrl1: 'https://055gc9w7ze.execute-api.ap-south-1.amazonaws.com/dev',
  apiFileUploadUrl: 'https://3fnfowmzxg.execute-api.us-west-2.amazonaws.com/dev/api/v1/document-upload/'
};
